'use client';

import { useDesign } from '@shaojiang/designs/runtime/useDesign';

/** The active design's motion presets (src/designs/<id>/index.ts). */
export function useDesignMotion() {
  return useDesign().design.motion;
}
